module.exports = __webpack_public_path__ + "static/step-3-2a497f6d3113b56f721da22ab823750f.jpg";